$(function () {
    $('.selectBox-value').on('click', function (e) {
        $('.items-select-option').toggleClass('d-none');
    });

    $('body').on('click', function (e) {
        if (e.target.closest('.selectBox-value') == null && e.target.closest('.items-select-option') == null ) {
            $('.items-select-option').addClass('d-none');
        }
    });

    $('.select-option').on('click', function (e) {
        $("select[name='sid']").val($(this).data("value")).trigger( "change" );
    });
})